/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../controls/controls.module.ts" />
/// <reference path="../../components/common/clientMembership.service.ts" />

module Meevo.Components.Filters {
    'use strict';

    import ClientMembershipDataService = Meevo.Components.Common.ClientMembershipDataService;
    import ClientMembershipIndicatorEnum = Meevo.Model.ClientMembershipIndicatorEnum;

    const ClientMembershipIconFilter = (clientMembershipDataService: ClientMembershipDataService) => {
        const filter: any = (clientMembershipIndicatorEnum: ClientMembershipIndicatorEnum): string => {
            return clientMembershipDataService.getClientMembershipIndicatorEnumIcon(clientMembershipIndicatorEnum);
        };

        return filter;
    };

    ClientMembershipIconFilter.$inject = ['meevo.components.common.ClientMembershipDataService'];

    angular.module('meevo.components.filters')
        .filter('meevoClientMembershipIcon', ClientMembershipIconFilter);
}
